import { Box, Container } from '@mui/material'
import { StandardPageHeader } from 'src/components/MUIBased/pageHeaders'
import { NavBarHeading } from 'src/components/MUIBased/NavBarHeading'
import { EditEmail } from 'src/pages/MUIBased/components/AccountDetails/EditEmail'

export const AccountDetails = () => {
    return (
        <>
            <StandardPageHeader />
            <NavBarHeading href="/mui/your-care">Account Details</NavBarHeading>
            <Container
                sx={{ display: 'flex', justifyContent: 'center', mt: '16px' }}
            >
                <Box sx={{ width: '480px', maxWidth: '100%' }}>
                    <EditEmail />
                </Box>
            </Container>
        </>
    )
}

export default AccountDetails
